import React from 'react';

import { LegacyBox, styled } from '@gogame/components';

export const DraggableHandlerContainer = styled(LegacyBox)`
  justify-content: center;
  align-items: center;
  height: 70px;
  width: 15px;
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
`;

export const AnchorWidgetStyled = styled(
  React.forwardRef(({ fullHeight: _, ...props }, ref) => {
    return <div {...props} ref={ref} />;
  })
)`
  min-height: ${(props) => (props.fullHeight ? '349px' : 'inherit')};
`;
